import { Content } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import { JSX } from 'react';
import styles from './index.module.scss';

export type OfferWallLendersProps =
  SliceComponentProps<Content.OfferWallLendersSlice>;

const OfferWallLenders = ({ slice }: OfferWallLendersProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={styles.section}
    >
      <div className={styles.title}>
        <PrismicRichText field={slice.primary.title} />
      </div>

      <div className={styles.logosWrapper}>
        {slice.primary.lenders.map((logo, index) => (
          <PrismicNextImage
            field={logo.image}
            key={index}
            className={styles.logo}
          />
        ))}
      </div>
    </section>
  );
};

export default OfferWallLenders;
